const DEFAULT = 'EM_BRANCO';
const MODEL = 'MODELO';
const PROFILE = 'PERFIL';
const PATTERN = 'PADRAO';
const COPY = 'COPIA';

export {
  DEFAULT,
  MODEL,
  PROFILE,
  PATTERN,  
  COPY,
};